import styled from 'styled-components';
import { Filter, ThreeDots, EditActionIcon } from '@/assets/icons';

const OptionsIcon = styled.div`
  width: 35px;
  height: 30px;
  mask-image: url(${ThreeDots});
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: 6px 19px;
  background-color: #0087dd;
  cursor: pointer;
`;

export { OptionsIcon };

const FilterIcon = styled.div`
  width: 30px;
  height: 30px;
  mask-image: url(${Filter});
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: 20px 20px;
  cursor: pointer;
  margin: 20px;
  padding: 10px;
`;

export { FilterIcon };

const EditActionButton = styled.div`
  width: 30px;
  height: 30px;
  mask-image: url(${EditActionIcon});
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: 20px 20px;
  background-color: #0087dd;
  cursor: pointer;
  margin: 20px;
  padding: 10px;
`;

export { EditActionButton };
